import React, {Component} from 'react'
import PropTypes from 'prop-types'
import {Button, Modal, notification, Input} from "antd"
import {markError} from "../../../../services/api/3dApi"
import { ERROR_DETAIL } from '../../helpers/errorDetail.json'
class MarkItemError extends Component {
    state = {
        loading: false,
        error: '',
        error_type: '',
        error_type_input: '',
    }

    _onMarkItemError = async () => {
        this.setState({
            loading: true,
            error: '',
        })

        try {
            const {inputValue, id} = this.props
            const {error_type, error_type_input} = this.state

            if(!!error_type && error_type.length > 100){
                this.setState({loading: false})
                return notification.error({
                    message: 'Đánh dấu lỗi không thành công',
                    description: `Nhập chi tiết lỗi tối đa 100 ký tự.`,
                })
            }

            const errorType = ERROR_DETAIL.find(error => error.name === error_type) || {}
            const {type_error = ''} = Object.assign({}, errorType)

            const payload = {
                error_type: !!type_error ? type_error : 'other',
                error_detail: error_type ? error_type : error_type_input,
                // error_procedure: 'qc_completed',
                error_style: null,
            }

            const {data: response} = await markError(id, payload)

            const {success, message} = response

            if (!success) {
                return this.setState({
                    loading: false,
                    error: message
                }, () => {
                    const {onClose} = this.props

                    if (typeof onClose === 'function') {
                        onClose()
                    }

                    notification.error({
                        message: 'Đánh dấu lỗi không thành công',
                        description: `Bạn đã đánh dấu lỗi cho item ${inputValue} không thành công`,
                    })
                })
            }

            this.setState({
                loading: false,
                error: '',
                error_type: '',
                error_type_input: '',
            }, () => {
                const {onClose, reset} = this.props

                if (typeof onClose === 'function' && typeof reset === 'function') {
                    onClose()
                    reset()
                }

                notification.success({
                    message: 'Đánh dấu lỗi thành công',
                    description: `Bạn đã đánh dấu lỗi cho item ${inputValue} thành công`,
                })
            })
        } catch (e) {
            this.setState({
                loading: false,
                error: e.message
            }, () => {
                notification.error({
                    message: 'Đánh dấu lỗi không thành công',
                    description: e.message,
                })
            })
        }
    }

    _handleChange = (name, value) => {
        if(name === "error_type_input"){
            this.setState({
                [name]: value,
                error_type: ''
            })
        }else{
            this.setState({
                [name]: value,
            })
        }
    }

    _onCloeModal = () => {
        this.setState({
            loading: false,
            error: '',
            error_style: 'detail',
            error_type: '',
            error_detail: '',
            error_type_input: '',
        }, () => {
            const {onClose} = this.props

            if (typeof onClose === 'function') {
                onClose()
            }
        })
    }

    render() {
        const {isOpen} = this.props
        const {loading, error_type, error_type_input } = this.state

        return (
            <div className="MarkItemError">
                <Modal
                    visible={isOpen}
                    title="Đánh dấu item QC lỗi"
                    onOk={this._onMarkItemError}
                    onCancel={this._onCloeModal}
                    className='MarkItemErrorModal MarkItemModalQCComplete markNoMultiple'
                    footer={[
                        <Button key="back" onClick={this._onCloeModal}>
                            Hủy
                        </Button>,
                        <Button key="submit" type="danger" loading={loading} onClick={this._onMarkItemError} disabled={!(error_type || error_type_input.trim())}>
                            Đánh dấu lỗi
                        </Button>
                    ]}
                >
                    <div className="Content">
                        <div className="ErrorStyle">
                            <label htmlFor="error_type" className="LabelError">Loại lỗi</label>
                            <div className="list-error-detail">
                                {ERROR_DETAIL.map((error, i) => (
                                    <div key={i} className={`error-item ${error_type === error.name ? 'error-bg' : ''}`} onClick={() => this._handleChange('error_type', error.name)}>
                                        {error.name}
                                    </div>
                                ))}
                                <div>
                                    <Input
                                        placeholder='Nhập lỗi khác'
                                        value={error_type_input}
                                        style={{ height: 37, textAlign: 'center' }}
                                        onChange={e => this._handleChange('error_type_input', e.target.value)}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </Modal>
            </div>
        )
    }
}

MarkItemError.propTypes = {
    isOpen: PropTypes.bool,
    inputValue: PropTypes.string,
    id: PropTypes.string,
    onClose: PropTypes.func.isRequired
}

export default MarkItemError
